import request from '../_helpers/request';
import axios from 'axios';
import { authHeader } from '../_helpers';
import { normalizeApiResponse } from '../_helpers/apiResponse';

const SCAN_PATH = 'ApiAi/businesslicense/scan';

function getAiApiBasePath() {
  return String(process.env.VUE_APP_WEBCOREAPI_AI_BASE_PATH || '').replace(/\/?$/, '/');
}

async function callBrApi(data, url) {
  const raw = await request({ url, method: 'post', data });
  return raw && typeof raw.isSuccessful === 'boolean'
    ? raw
    : normalizeApiResponse(raw);
}

function withOptionalEmpCompanyId(payload, data) {
  if (data?.empCompanyId != null && data.empCompanyId !== '') {
    payload.empCompanyId = Number(data.empCompanyId);
  }
  return payload;
}

export const BusinessRegistrationService = {
  GetSummary: (data = {}) => callBrApi(data, 'BusinessRegistration/GetSummary'),
  GetList: (data = {}) => callBrApi(data, 'BusinessRegistration/GetList'),
  GetAccessGate: () => callBrApi({}, 'BusinessRegistration/GetAccessGate'),
  SaveDocument: (data) => callBrApi(
    withOptionalEmpCompanyId({
      companyName: data?.companyName ?? '',
      registrationNo: data?.registrationNo ?? '',
      issueDate: data?.issueDate,
      expiryDate: data?.expiryDate,
      mediaFileName: data?.mediaFileName ?? '',
      ocrPayloadJson: data?.ocrPayloadJson ?? '',
      ocrCompanyName: data?.ocrCompanyName ?? '',
      ocrRegistrationNo: data?.ocrRegistrationNo ?? '',
      displayNameEn: data?.displayNameEn ?? '',
      displayNameZh: data?.displayNameZh ?? '',
    }, data),
    'BusinessRegistration/SaveDocument',
  ),
  EnqueueForApproval: (data) => callBrApi(
    withOptionalEmpCompanyId({
      businessRegistrationId: Number(data?.businessRegistrationId),
      accountId: data?.accountId != null ? Number(data.accountId) : undefined,
      submitType: data?.submitType || undefined,
    }, data),
    'BusinessRegistration/EnqueueForApproval',
  ),
  AcknowledgeResultNotify: (data = {}) => callBrApi(data, 'BusinessRegistration/AcknowledgeResultNotify'),
  GetPendingNameChange: () => callBrApi({}, 'BusinessRegistration/GetPendingNameChange'),
  GetAdminPending: (empCompanyId) => callBrApi(
    { empCompanyId: Number(empCompanyId) },
    'BusinessRegistration/GetAdminPending',
  ),
  RequestDisplayNameChange(data) {
    return callBrApi({
      sourceApprovalId: Number(data?.sourceApprovalId),
      displayNameEn: data?.displayNameEn ?? '',
      displayNameZh: data?.displayNameZh ?? '',
      empCompanyId: data?.empCompanyId != null ? Number(data.empCompanyId) : undefined,
      accountId: data?.accountId != null ? Number(data.accountId) : undefined,
      submitType: data?.submitType || undefined,
    }, 'BusinessRegistration/RequestDisplayNameChange');
  },
  AdminProcess(data) {
    return callBrApi({
      empCompanyId: Number(data?.empCompanyId),
      approvalId: Number(data?.approvalId),
      action: String(data?.action || '').toUpperCase(),
      rejectReason: data?.rejectReason || '',
    }, 'BusinessRegistration/AdminProcess');
  },
  SoftDeleteDocument(data = {}) {
    return callBrApi(
      withOptionalEmpCompanyId(
        { businessRegistrationId: Number(data?.businessRegistrationId) },
        data,
      ),
      'BusinessRegistration/SoftDeleteDocument',
    );
  },
  SetAsCurrent(data = {}) {
    return callBrApi(
      withOptionalEmpCompanyId({ approvalId: Number(data?.approvalId) }, data),
      'BusinessRegistration/SetAsCurrent',
    );
  },
  ScanBusinessLicense,
};

async function ScanBusinessLicense(file) {
  const url = `${getAiApiBasePath()}${SCAN_PATH}`;
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await axios.post(url, formData, {
      headers: { ...authHeader() },
      timeout: 120000,
    });
    return {
      ...normalizeApiResponse(response.data),
      httpStatus: response.status,
    };
  } catch (error) {
    const responseData = error.response?.data;
    return {
      ...normalizeApiResponse(
        responseData && typeof responseData === 'object' && Object.keys(responseData).length
          ? responseData
          : { IsSuccessful: false, Msg: error.message || 'scan failed', Data: null },
      ),
      httpStatus: error.response?.status,
    };
  }
}
